var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[(_vm.loading && _vm.delayElapsed)?_c('Loading'):_vm._e(),(_vm.error)?_c('Error',{attrs:{"error":_vm.error}}):_vm._e(),(_vm.thisProject)?_c('div',[_c('router-view',{key:_vm.$route.path,attrs:{"thisProject":_vm.thisProject}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }